const { routeNames } = require('../../constants');

export default {
  computed: {
    hasDiscoveredTLabelAssets() {
      return this.$store.getters['mobileApp/tLabels/hasDiscoveredTLabelAssets'];
    },
    bulkDownloadInProgress() {
      return this.$store.getters['mobileApp/tLabels/bulkDownloadInProgress'];
    },
    totalDiscoveredTLabels() {
      return this.$store.getters['mobileApp/tLabels/discoveredTLabelAssets'].length;
    },
    downloadedLabelsCount() {
      return this.$store.getters['mobileApp/tLabels/downloadedLabelsCount'];
    },
  },
  watch: {
    hasDiscoveredTLabelAssets(newValue) {
      if (newValue) {
        this.$store.commit('bannerAlert/SET_BANNER_ALERT', {
          hasAlert: true,
          message: 'Temperature Labels Detected',
          action: {
            text: 'View',
            to: {
              name: routeNames.temperature.download,
            },
          },
          icon: 'mdi-thermometer-alert',
        });
      } else if (!this.bulkDownloadInProgress) {
        this.$store.commit('bannerAlert/RESET_STATE');
      }
    },
    bulkDownloadInProgress(newValue) {
      if (newValue) {
        this.updateTLabelInProgressBanner();
      } else {
        this.$store.commit('bannerAlert/RESET_STATE');
      }
    },
    totalDiscoveredTLabels() {
      if (this.bulkDownloadInProgress) {
        this.updateTLabelInProgressBanner();
      }
    },
    downloadedLabelsCount() {
      if (this.bulkDownloadInProgress) {
        this.updateTLabelInProgressBanner();
      }
    },
  },
  methods: {
    updateTLabelInProgressBanner() {
      const total = this.totalDiscoveredTLabels;
      const completed = this.downloadedLabelsCount;

      if (total === 0) {
        // Reset the banner alert if no labels are for download
        this.$store.commit('bannerAlert/RESET_STATE');
        return;
      }

      const detail = `${completed} of ${total} complete (${Math.round((completed / (total || 1)) * 100)}%)`;

      this.$store.commit('bannerAlert/SET_BANNER_ALERT', {
        hasAlert: true,
        message: 'Temperature Download Running',
        detail,
        action: {
          text: 'View',
          to: {
            name: routeNames.temperature.download,
          },
        },
        icon: 'mdi-download',
      });
    },
  },
};
